import React, { useEffect, useState } from 'react'
import TextFieldUniversal from '../../../../../../../validate/form/text/TextFieldUniversal'

const PaymentBillNumberField = ({ required, setValidate, setValueForm, forciblyValue }) => {

  	const [value, setValue] = useState('')

  return (
	<TextFieldUniversal
        value={value}
        setValue={e => {
            setValueForm(e)
            setValue(e)
        }}
        setValidate={setValidate}
        label={'Номер рахунку'} 
        placeholder={'Рахунок №777 від 30.09.2025'}
        validates={{
            isEmpty: true,
        }}
        forciblyValue={forciblyValue}
        required={required}
    />
  )
}

export default PaymentBillNumberField